import React from 'react';
import { Checkmark } from '../../../../static/icons/checkmark';
import { cnMerge } from '../../../utils/utils';

export const Checkbox = ({ title, disabled, error, className, ...props }) => (
  <div className="relative flex items-center">
    <input
      type="checkbox"
      className={cnMerge(
        `before:content[''] peer relative h-5 w-5 appearance-none rounded-[4px] border border-customGray-400 checked:border-primary-700 bg-white checked:bg-primary-700 checked:before:bg-primary-700 ${error && '!border-red-400'}  ${disabled ? 'opacity-50' : 'global-hover'}`,
        className
      )}
      id={title ?? ''}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
      <Checkmark />
    </span>
  </div>
);
